import { useEffect, useRef } from "react";

export const useKeydown = (
  callback: (event: KeyboardEvent) => void,
  enabled = true,
) => {
  const callbackReference = useRef(callback);

  useEffect(() => {
    callbackReference.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const handler = (event: KeyboardEvent) => {
      callbackReference.current(event);
    };

    document.addEventListener("keydown", handler);

    return () => {
      document.removeEventListener("keydown", handler);
    };
  }, [enabled]);
};
